<section>
  <h3 nz-typography>{{ 'AUCTION.DELIVERY_CALC.DELIVERY_CALC' | translate }}</h3>
  <form nz-row nz-form [formGroup]="form" nzLayout="vertical" nzGutter="10">
    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="7">
      <nz-form-item>
        <nz-form-label nzRequired
          >{{ 'AUCTION.DELIVERY_CALC.DESTINATION' | translate }}:</nz-form-label
        >
        <nz-form-control>
          <nz-select
            nzAllowClear
            formControlName="destination"
            nzDropdownClassName="skiptranslate"
            [nzPlaceHolder]="'AUCTION.DELIVERY_CALC.DESTINATION_PLACEHOLDER' | translate"
          >
            <nz-option
              *ngFor="let item of destinations"
              [nzValue]="item.value"
              [nzLabel]="item.label | translate"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="7">
      <nz-form-item>
        <nz-form-label nzRequired>{{ 'AUCTION.DELIVERY_CALC.CITY' | translate }}:</nz-form-label>
        <nz-form-control>
          <nz-select
            formControlName="city"
            nzShowSearch
            nzAllowClear
            nzDropdownClassName="skiptranslate"
            [nzPlaceHolder]="'AUCTION.DELIVERY_CALC.CITY_PLACEHOLDER' | translate"
            [nzFilterOption]="false"
            [nzServerSearch]="true"
            (nzOnSearch)="onCitySearch($event)"
          >
            <nz-option
              *ngFor="let city of filteredCities$ | async"
              [nzValue]="city.code"
              [nzLabel]="getCityDisplayName(city)"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="5">
      <nz-form-item>
        <nz-form-label nzRequired>{{ 'AUCTION.DELIVERY_CALC.WEIGHT' | translate }}:</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="weight"
            type="number"
            appRestrictionsInput
            [blockNegative]="true"
            [resetNegative]="true"
            min="0.1"
            step="0.1"
          />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="5">
      <nz-form-item>
        <nz-form-label nzRequired
          >{{ 'AUCTION.DELIVERY_CALC.INSURANCE' | translate }}:</nz-form-label
        >
        <nz-form-control>
          <input
            nz-input
            formControlName="insurance"
            type="number"
            maxlength="15"
            appRestrictionsInput
            [blockNegative]="true"
            [resetNegative]="true"
            min="0"
          />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="9">
      <nz-form-item>
        <nz-form-label>{{ 'AUCTION.DELIVERY_CALC.ZIP' | translate }}:</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="zip"
            type="number"
            appRestrictionsInput
            [blockNegative]="true"
            [resetNegative]="true"
            min="0"
            [placeholder]="'AUCTION.DELIVERY_CALC.ZIP_PLACEHOLDER' | translate"
          />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="5">
      <nz-form-item>
        <nz-form-label>{{ 'AUCTION.DELIVERY_CALC.LENGTH' | translate }}:</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="length"
            type="number"
            maxlength="15"
            appRestrictionsInput
            [blockNegative]="true"
            [resetNegative]="true"
            min="0"
          />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="5">
      <nz-form-item>
        <nz-form-label>{{ 'AUCTION.DELIVERY_CALC.WIDTH' | translate }}:</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="width"
            type="number"
            maxlength="15"
            appRestrictionsInput
            [blockNegative]="true"
            [resetNegative]="true"
            min="0"
          />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="5">
      <nz-form-item>
        <nz-form-label>{{ 'AUCTION.DELIVERY_CALC.HEIGHT' | translate }}:</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="height"
            type="number"
            maxlength="15"
            appRestrictionsInput
            [blockNegative]="true"
            [resetNegative]="true"
            min="0"
          />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24">
      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="calculate()" [disabled]="!form.valid">
            {{ 'AUCTION.DELIVERY_CALC.CALCULATE' | translate }}
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </form>

  <div nz-row class="rates" [nzGutter]="[10, 10]" nzJustify="center">
    <div *ngIf="loading$ | async" nz-col [nzSpan]="24">
      <nz-spin [nzSpinning]="true" nzSize="large">
        <div class="payload"></div>
      </nz-spin>
    </div>

    <div
      *ngIf="(rates$ | async)?.length === 0 && (loading$ | async) === false"
      nz-col
      [nzSpan]="24"
    >
      <nz-empty [nzNotFoundContent]="'AUCTION.DELIVERY_CALC.NO_RATES' | translate"></nz-empty>
    </div>
    <div *ngFor="let rate of rates$ | async" nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" class="stat">
      <nz-descriptions nzBordered nzSize="small" nzLayout="vertical">
        <nz-descriptions-item [nzTitle]="getRateName(rate)">
          <app-currency
            [value]="rate.price"
            [exchangeRate]="exchangeRate"
            layout="vertical"
          ></app-currency>
        </nz-descriptions-item>
      </nz-descriptions>
    </div>
  </div>
</section>
